import { Info } from '@phosphor-icons/react';

export default function PublicInfoPage() {
  return (
    <div className="max-w-[700px] mx-auto px-4 py-16 text-center">
      <div className="flex items-center justify-center mb-3">
        <Info size={36} weight="duotone" className="text-brand-primary" />
      </div>
      <h1 className="text-2xl font-semibold mb-2">Zona clienți dezShop</h1>
      <p className="text-gray-700 mb-6">
        Această secțiune ajută clienții cu oferte, vânzări și retururi. <br />
        Folosește linkul primit de la noi pentru a continua.

      </p>
    </div>
  );
}



